import React, { Component } from "react";
import { Button, Modal, Row, Col } from "react-bootstrap";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
} from "react-bootstrap-table";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import AddToGroupLock from "./AddToGroupLock";
import RemoveFromGroupLock from "./RemoveFromGroupLock";
import { updateGroupLocks } from "./GroupManagementHelper";

import LocalizedStrings from "react-localization";
import { all } from "bluebird";

let localizationStrings = new LocalizedStrings({
  en: {
    lockManageTitle: "Manage Locks",
    lockNameTitle: "Lock",
    resultTitle3: "",
    resultTitle4: "",
    submitButton: "Submit",
    closeButton: "Close",
  },
  ja: {
    lockManageTitle: "ロック管理",
    lockNameTitle: "ロック",
    resultTitle3: "",
    resultTitle4: "",
    submitButton: "送信",
    closeButton: "閉じる",
  },
  es: {
    lockManageTitle: "Gestionar Bloqueos",
    lockNameTitle: "Bloqueo",
    resultTitle3: "",
    resultTitle4: "",
    submitButton: "Enviar",
    closeButton: "Cerrar",
  },
});

class LocksButton extends Component {
  constructor(props) {
    super(props);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.customConfirmDialog = this.customConfirmDialog.bind(this);
    this.createCustomSearchField = this.createCustomSearchField.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.renderAddToGroupLockBtn = this.renderAddToGroupLockBtn.bind(this);
    this.renderRemoveFromGroupLockBtn = this.renderRemoveFromGroupLockBtn.bind(
      this
    );
    this.updateGroupLocks = this.updateGroupLocks.bind(this);
    this.unselectLock = this.unselectLock.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    // const cell = this.props.cellValue;
    // const row = this.props.rowValue;

    this.state = {
      // cell: cell,
      // row: row,
      allLocks: [], // All super admin's locks
      groupLocks: [], // All locks in the particular group
      noDataText: "loading...",
      showPopup: false,
      loading: false,
      _notificationSystem: null,
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };

  componentWillMount() {
    // console.log(this.props.groupUid)
    const groupUid = this.props.groupUid;
    // var groupLocksArray = [];
    // var allLocksArray = [];

    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        // console.log(snapshot.val())
        var allLocksArray = [];
        allLocksArray = this.snapshotToArray(snapshot);

        fire
          .database()
          .ref("groupLocks/" + auth.currentUser.uid + "/" + groupUid)
          // .child(groupUid)
          .once("value")
          .then((snapshot) => {
            if (snapshot.exists()) {
              var groupLocksArray = [];
              groupLocksArray = this.snapshotToArray(snapshot);
              // groupLocksArray = tempArray;

              groupLocksArray.forEach((eachLock) => {
                // console.log(eachLock.lockId)
                const idx = allLocksArray.findIndex(
                  (lock) => lock.ip45SerialNumber === eachLock.ip45SerialNumber
                );
                // console.log(idx);

                if (idx >= 0) {
                  allLocksArray.splice(idx, 1);
                }
              });
              this.setState({
                allLocks: allLocksArray,
                groupLocks: groupLocksArray,
              });
            } else {
              this.setState({
                allLocks: allLocksArray,
              });
            }
          });
      });

    // allGroupLocksArray.forEach((eachLock) => {
    //   const idx = allLocksArray.findIndex((lock) =>
    //     lock.id === eachLock.lockId)

    //   if (idx >= 0) {
    //     allLocksArray.splice(idx, 1)
    //   }
    // })
    // console.log(allLocksArray)
    // console.log(allGroupLocksArray)
    // this.setState({
    //   allLocks: allLocksArray,
    //   allGroupLocks: allGroupLocksArray,
    // })
  }

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'

    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  handleShow() {
    this.setState({ showPopup: true });
  }

  handleClose() {
    this.setState({ showPopup: false });
  }

  customConfirmDialog(next) {
    next();
  }

  onAfterDeleteRow(rowKeys) {
    //"A111111"
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="searchBar"
        // id="retractSearch"
        placeholder="Search"
      />
    );
  };

  updateGroupLocks(data) {
    customLog(data);

    const allLocks = this.state.allLocks;
    const idx = allLocks.findIndex((lock) => lock.id === data[0].lockId);

    if (idx >= 0) {
      allLocks.splice(idx, 1);
    }

    this.setState({
      allLocks: allLocks,
      //   // selectedMembersToAdd: [...this.state.selectedMembersToAdd, data[0]],
      groupLocks: [...this.state.groupLocks, data[0]],
    });
    customLog("SAY HEYAYAYAYA");
  }

  unselectLock(data) {
    customLog(data);

    const groupLocks = this.state.groupLocks;
    const idx = groupLocks.findIndex((lock) => lock.lockId === data[0].lockId);
    customLog(idx);

    if (idx >= 0) {
      groupLocks.splice(idx, 1);
    }

    this.setState({
      groupLocks: groupLocks,
      allLocks: [...this.state.allLocks, data[0]],
    });

    customLog("SAY NONONONONONO");
  }

  renderAddToGroupLockBtn(col, row) {
    customLog("Add Lock Btn Pressed");
    customLog(row);
    return <AddToGroupLock data={row} dataCallBack={this.updateGroupLocks} />;
  }

  renderRemoveFromGroupLockBtn(col, row) {
    customLog("REMOVE BTN");
    customLog(row);
    return <RemoveFromGroupLock data={row} dataCallBack={this.unselectLock} />;
  }

  onSubmit() {
    //! SUBMIT TO FIREBASE
    const locksToUpdate = this.state.groupLocks;
    const groupId = this.props.groupUid;

    updateGroupLocks(locksToUpdate, groupId, (callback) => {
      if (callback.done) {
        this.showNotification(
          "Group Locks successfully updated !",
          "success",
          "tc",
          3
        );
        this.handleClose();
      } else {
        this.showNotification("Update Failed !", "error", "tc", 3);
        this.handleClose();
      }
    });
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const options = {
      // handleConfirmDeleteRow: confirmRemove,
      page: 1, // which page you want to show as default
      sizePerPageList: [
        {
          text: "5",
          value: 5,
        },
      ], // you can change the dropdown list for size per page
      sizePerPage: 5, // which size per page you want to locate as default
      // pageStartIndex: 1, // where to start counting the pages
      pagination: false,
      // paginationSize: 10, // the pagination bar size.
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      searchField: this.createCustomSearchField,
    };

    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Modal
          dialogClassName="modal-90w"
          show={this.state.showPopup}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>{localizationStrings.lockManageTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <section>
              <Row className="show-grid">
                <Col xs={6}>
                  <h3>All Locks</h3>
                  <BootstrapTable
                    id="table"
                    pagination={true}
                    bordered={false}
                    data={this.state.allLocks}
                    // selectRow={selectRowPropForSuperAdmin}
                    options={options}
                    search
                  >
                    <TableHeaderColumn
                      dataSort
                      hidden
                      dataField="lockId"
                      isKey
                    />
                    <TableHeaderColumn dataSort dataField="Name">
                      {localizationStrings.lockNameTitle}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="lockId"
                      dataFormat={this.renderAddToGroupLockBtn}
                    ></TableHeaderColumn>
                  </BootstrapTable>
                </Col>
                <Col xs={1} />
                <Col xs={5}>
                  <h3>Selected Locks</h3>
                  <BootstrapTable
                    id="table"
                    pagination={true}
                    bordered={false}
                    options={options}
                    data={this.state.groupLocks}
                  >
                    <TableHeaderColumn dataSort hidden dataField="lockId" />
                    <TableHeaderColumn dataSort dataField="Name" isKey>
                      {localizationStrings.lockNameTitle}
                    </TableHeaderColumn>

                    <TableHeaderColumn
                      dataField="lockId"
                      dataFormat={this.renderRemoveFromGroupLockBtn}
                    ></TableHeaderColumn>
                  </BootstrapTable>
                </Col>
              </Row>
            </section>
          </Modal.Body>
          <Modal.Footer>
            <div className={"flex"}>
              <Button
                className="submitBtn"
                // disabled={isInvalid}
                type="submit"
                onClick={this.onSubmit}
              >
                {localizationStrings.submitButton}
              </Button>
              <Button onClick={this.handleClose} className="closeBtn">
                {localizationStrings.closeButton}
              </Button>
            </div>
          </Modal.Footer>
        </Modal>

        <button onClick={this.handleShow} className="loginsignupbutton">
          <strong>{localizationStrings.lockManageTitle}</strong>
        </button>
      </div>
    );
  }
}

export default LocksButton;
